import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import Sidebar from "../../../components/Sidebar";
import TopBar from "../../../components/TopBar";
import MemberDetails from "../../../components/MemberDetails/MemberDetails";
import PractitionerDetail from "../../../components/PractitionerDetail/PractitionerDetail";
import { getPractitionerDetail, clearPractitionerDetail } from "../../../api/Practitioner/PractitionerDetail";

export default function Index() {
  const [collapsed, setCollapsed] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { counsellorId } = useParams();

  // Redux state
  const { data: practitionerData, loading, error } = useSelector(state => state.practitionerDetail);

  // Fetch practitioner details on mount
  useEffect(() => {
    if (counsellorId) {
      dispatch(getPractitionerDetail(counsellorId));
    }

    // Cleanup on unmount
    return () => {
      dispatch(clearPractitionerDetail());
    };
  }, [dispatch, counsellorId]);

  const handleBack = () => {
    navigate('/practitioner');
  };

  const handleClose = () => {
    navigate('/practitioner');
  };

  const handleShare = () => {
    console.log("Share clicked");
  };

  const handleExport = () => {
    console.log("Export clicked");
  };
  return (
    <div className="fixed inset-x-0 bottom-0 top-16 flex bg-[#F8FAFC] overflow-hidden">
      <TopBar />

      {/* Sidebar */}
      <div
        className={`hidden lg:flex ${collapsed ? "w-[64px]" : "w-[272px]"} fixed top-0 left-0 h-screen z-20`}
      >
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      </div>
      <div
        className={`flex-1 min-w-0 font-poppins overflow-auto bg-[#F8FAFC] pt-2 px-2 pb-8 transition-all duration-300 ${
          collapsed ? "lg:ml-[64px]" : "lg:ml-[272px]"
        } max-lg:ml-0`}
      >
        <div className="bg-[#FFFFFF] min-h-screen rounded-2xl max-lg:rounded-none w-full">
          <div className="w-full p-4 md:p-6 bg-[#FFFFFF] rounded-2xl max-lg:rounded-none">
            {loading ? (
              <div className="flex justify-center items-center h-64">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#2563EB]"></div>
                <span className="ml-3 text-[#64748B] font-poppins">Loading practitioner details...</span>
              </div>
            ) : error ? (
              <div className="flex justify-center items-center h-64">
                <div className="text-center">
                  <p className="text-[#DC2626] mb-4 font-poppins">Error: {error}</p>
                  <button
                    onClick={() => dispatch(getPractitionerDetail(counsellorId))}
                    className="btn-gradient h-9 px-[14px] text-[13px] font-semibold rounded-xl border-0 hover:opacity-95 transition"
                  >
                    Retry
                  </button>
                </div>
              </div>
            ) : (
              <PractitionerDetail
                practitionerData={practitionerData}
                onBack={handleBack}
                onClose={handleClose}
                onShare={handleShare}
                onExport={handleExport}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
